import ExternalBankOfTalents from './ExternalBankOfTalents';

export default ExternalBankOfTalents;
